/// <amd-module name="SuiteCommerce.GridOrder.Common.InstrumentationHelper"/>
define("SuiteCommerce.GridOrder.Common.InstrumentationHelper", ["require", "exports", "SuiteCommerce.GridOrder.Instrumentation"], function (require, exports, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ComponentArea = 'SC Grid Order';
    exports.ExtensionVersion = '1.0.5';
    exports.QueueNameSuffix = '-GridOrder';
    var InstrumentationHelper = /** @class */ (function () {
        function InstrumentationHelper() {
        }
        InstrumentationHelper.initializeInstrumentation = function (environment) {
            Instrumentation_1.default.initialize({
                environment: environment,
                queueNameSuffix: exports.QueueNameSuffix,
                defaultParameters: {
                    componentArea: exports.ComponentArea,
                    extensionVersion: exports.ExtensionVersion,
                },
            });
        };
        return InstrumentationHelper;
    }());
    exports.InstrumentationHelper = InstrumentationHelper;
});
